(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"), require("moment"));
	else if(typeof define === 'function' && define.amd)
		define(["vue", "moment"], factory);
	else if(typeof exports === 'object')
		exports["antd"] = factory(require("vue"), require("moment"));
	else
		root["antd"] = factory(root["Vue"], root["moment"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_vue__, __WEBPACK_EXTERNAL_MODULE_moment__) {
return 